import Dropdown from "../global/Dropdown";
import { menuItemClasses } from "@mui/material";
import { ChevronDown } from "react-feather";

const DbtProfileDropdown = ({
  dbtProfile,
  setDbtProfile,
  dbtProfiles,
  className = "",
  sx,
  darkMode = false
}) => {
  return (
    <Dropdown>
      <Dropdown.Button
        onClick={(e) => e.stopPropagation()}
        className={className}
        sx={{
          borderRadius: 0,
          border: "none",
          zIndex: 10000,
          height: "24.66px",
          width: "80px",
          paddingRight: 0,
          paddingLeft: 0,
          whiteSpace: "nowrap",
          padding: "0.15rem 0.50rem",
          fontSize: "11px",
          backgroundColor: "#495057",
          borderColor: "#495057",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#3e444a",
            borderColor: "#3a4046",
          },
          "&:disabled": {
            backgroundColor: "#495057",
            color: "#fff",
          },
          "&:focus": {
            boxShadow: "0 0 0 0.2rem rgba(100, 106, 112, 0.5)"
          },
          ...sx
        }}
        endIcon={
          dbtProfile ? <ChevronDown size={12} strokeWidth={4} /> : undefined
        }
        disabled={!dbtProfile}
      >
        {dbtProfile || "Loading..."}
      </Dropdown.Button>

      <Dropdown.Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: darkMode ? {
            backgroundColor: '#252526',
            border: '1px solid #3c3c3c',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
          } : {}
        }}
      >
        {/* Add a non-selectable header */}
        <Dropdown.Header sx={{ color: darkMode ? '#cccccc' : undefined, backgroundColor: darkMode ? '#252526' : undefined }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            height="16"
            width="16"
          >
            <desc>Dbt Icon</desc>
            <path
              fill={"#ff694a"} // DBT orange color
              d="M22.75135 1.2273975C23.303775 1.75859 23.665 2.459765 23.75 3.224675c0 0.318725 -0.085 0.5312 -0.276225 0.934925 -0.191225 0.4037 -2.549725 4.483275 -3.2509 5.6094 -0.4037 0.658675 -0.616175 1.44485 -0.616175 2.20975 0 0.786175 0.212475 1.5511 0.616175 2.209775 0.701175 1.126125 3.059675 5.226925 3.2509 5.63065C23.665 20.222875 23.75 20.4141 23.75 20.7328c-0.085 0.764925 -0.42495 1.466125 -0.9774 1.976075 -0.5312 0.552425 -1.23235 0.91365 -1.976025 0.977375 -0.318725 0 -0.5312 -0.084975 -0.91365 -0.276225 -0.382475 -0.191225 -4.547025 -2.485975 -5.673175 -3.18715 -0.084975 -0.0425 -0.169975 -0.106225 -0.2762 -0.14875L8.36665 16.780725c0.127475 1.0624 0.594925 2.0823 1.359825 2.825975 0.14875 0.148725 0.2975 0.276225 0.467475 0.4037 -0.1275 0.063725 -0.276225 0.1275 -0.4037 0.212475 -1.12615 0.701175 -5.22695 3.059675 -5.63065 3.2509C3.755875 23.665 3.56465 23.75 3.224675 23.75c-0.76491 -0.085 -1.466085 -0.42495 -1.9760325 -0.9774C0.6962025 22.2414 0.33499 21.54025 0.25 20.775325c0.0212475 -0.318725 0.10624 -0.637425 0.2762225 -0.91365 0.19123 -0.403725 2.5497275 -4.50455 3.2509025 -5.630675 0.403725 -0.658675 0.616175 -1.4236 0.616175 -2.20975 0 -0.786175 -0.21245 -1.5511 -0.616175 -2.209775 -0.701175 -1.1686 -3.0809225 -5.269425 -3.2509025 -5.67315C0.35624 3.8621 0.2712475 3.5434 0.25 3.224675c0.08499 -0.76491 0.424955 -1.466085 0.9773975 -1.9972775C1.75859 0.674955 2.459765 0.33499 3.224675 0.25c0.318725 0.0212475 0.637425 0.10624 0.934925 0.2762225 0.33995 0.1487325 3.335875 1.8910475 4.92945 2.8259525l0.361225 0.212475c0.127475 0.085 0.233725 0.148725 0.318725 0.191225l0.169975 0.106225 5.673125 3.357175c-0.127475 -1.274875 -0.78615 -2.443525 -1.80605 -3.229675 0.1275 -0.063725 0.276225 -0.1275 0.4037 -0.212475 1.12615 -0.701175 5.22695 -3.0809225 5.63065 -3.2509025 0.27625 -0.1699825 0.59495 -0.254975 0.934925 -0.2762225 0.743675 0.08499 1.44485 0.424955 1.976025 0.9773975ZM12.29745 13.5086l1.21115 -1.21115c0.169975 -0.169975 0.169975 -0.424925 0 -0.5949l-1.21115 -1.21115c-0.169975 -0.169975 -0.424925 -0.169975 -0.5949 0l-1.21115 1.21115c-0.169975 0.169975 -0.169975 0.424925 0 0.5949l1.21115 1.21115c0.148725 0.148725 0.424925 0.148725 0.5949 0Z"
              strokeWidth="0.25"
            />
          </svg>
          DBT Profile(s)
        </Dropdown.Header>
        <Dropdown.Divider sx={{ borderColor: darkMode ? '#3c3c3c' : undefined }} />
        {/* Map over the dbtProfiles array from state */}
        {dbtProfiles && dbtProfiles.length > 0 ? (
          dbtProfiles.map((profile) => (
            <Dropdown.MenuItem
              sx={{
                fontSize: "11px",
                color: darkMode ? '#cccccc' : 'inherit',
                '&:hover': {
                  backgroundColor: darkMode ? '#094771' : undefined,
                },
                [`&.${menuItemClasses.selected}`]: {
                  backgroundColor: "#3F80EA",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#3F80EA",
                    color: "#fff",
                  },
                },
              }}
              key={profile}
              onClick={() => {
                setDbtProfile(profile);
                localStorage.setItem("selectedDbtProfile", profile);
              }}
              selected={dbtProfile === profile}
            >
              {profile}
              {dbtProfile === profile && (
                <span style={{ color: "green", marginLeft: "5px" }}>✓</span>
              )}
            </Dropdown.MenuItem>
          ))
        ) : (
          <Dropdown.MenuItem
            disabled
            sx={{
              fontSize: "11px",
              color: darkMode ? '#858585' : undefined,
            }}
          >
            Loading profiles...
          </Dropdown.MenuItem>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DbtProfileDropdown;
